<ion-content>
  <app-register-form (submitForm)="requestNewUser($event)"></app-register-form>
  
  <app-button-language></app-button-language>
</ion-content>
